export default {
    title: 'Exports',
    description: 'Every export of the organization’s library is on record here — each workspace’s and the whole organization’s — with who asked for it, when, and where from.',
    formTitle: 'Export the whole library',
    formDescription: 'One row per asset, across every workspace — pending and rejected assets included, the trash excluded. The file is prepared in the background and emailed to you when it is ready.',
    disabled: 'Library exports are not enabled for this organization. The log of past exports stays readable below.',
}
